{
  "jira-nin-grouping-with-hierarchy-spotlight.spotlightDismissButton": [
    {
      "type": 0,
      "value": "Done"
    }
  ],
  "jira-nin-grouping-with-hierarchy-spotlight.spotlightHeading": [
    {
      "type": 0,
      "value": "Show hierarchy when grouping"
    }
  ],
  "jira-nin-grouping-with-hierarchy-spotlight.spotlightImageAltText": [
    {
      "type": 0,
      "value": "Illustration of the hierarchy toggle enabled when grouping is applied in the List View."
    }
  ],
  "jira-nin-grouping-with-hierarchy-spotlight.spotlightManageHierarchyDescription": [
    {
      "type": 0,
      "value": "To manage hierarchy, select "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "More actions (...)"
        }
      ],
      "type": 8,
      "value": "b"
    },
    {
      "type": 0,
      "value": " at the top-right of your list."
    }
  ],
  "jira-nin-grouping-with-hierarchy-spotlight.spotlightSeeRelationshipsDescription": [
    {
      "type": 0,
      "value": "See relationships between work items when you group the list view."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.closeButton": [
    {
      "type": 0,
      "value": "Close"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsDescriptionContentRefresh": [
    {
      "type": 0,
      "value": "Want to use the same settings that you're currently using in List? This includes filters, groups and columns you've set."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltText": [
    {
      "type": 0,
      "value": "Illustration of multiple spaces stacked to show everything will migrate together."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextCurrentSpace": [
    {
      "type": 0,
      "value": "Illustration of a single space showing the list settings will migrate to the new view."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsImageAltTextNo": [
    {
      "type": 0,
      "value": "Illustration of a cursor selecting the More actions menu to choose migrate later."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoContentRefresh": [
    {
      "type": 0,
      "value": "Don't apply current settings"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsNoDescriptionContentRefresh": [
    {
      "type": 0,
      "value": "Update settings later in More actions (...)"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesAllSpacesContentRefresh": [
    {
      "type": 0,
      "value": "Apply current settings for all spaces I use"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.copyListSettingsYesSingleSpaceContentRefresh": [
    {
      "type": 0,
      "value": "Apply current settings for "
    },
    {
      "type": 1,
      "value": "spaceName"
    },
    {
      "type": 0,
      "value": " space only"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.descriptionContentRefresh": [
    {
      "type": 0,
      "value": "We've combined the best of List and All work into "
    },
    {
      "children": [
        {
          "type": 0,
          "value": "one powerful, unified view for managing work items."
        }
      ],
      "type": 8,
      "value": "link"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.headingContentRefresh": [
    {
      "type": 0,
      "value": "A single, more powerful List view"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spaceNameFallback": [
    {
      "type": 0,
      "value": "current"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.apply-settings-button-label": [
    {
      "type": 0,
      "value": "Apply settings"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.dismiss": [
    {
      "type": 0,
      "value": "Dismiss"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.explore-list-view-button-label": [
    {
      "type": 0,
      "value": "Explore List view"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.filter": [
    {
      "type": 0,
      "value": "Search, filter, and group work items to quickly find what you need."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.more-actions": [
    {
      "type": 0,
      "value": "Adjust how you visualise the work with charts and format rules. You can also apply your old list settings."
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.next": [
    {
      "type": 0,
      "value": "Next"
    }
  ],
  "jira-nin-paid-list-merge-modal-onboarding.spotlight.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira.nin.filter.refinement.filter-popup.changeboarding.ok": [
    {
      "type": 0,
      "value": "OK"
    }
  ],
  "jira.nin.filter.refinement.filter-popup.changeboarding.text": [
    {
      "type": 0,
      "value": "Find work faster using filters."
    }
  ],
  "jira.nin.filter.refinement.filter-popup.changeboarding.text.advanced.jql": [
    {
      "type": 0,
      "value": "Select advanced or JQL mode to filter by more fields."
    }
  ],
  "jira.nin.filter.refinement.filter-popup.changeboarding.title": [
    {
      "type": 0,
      "value": "A new home for filters"
    }
  ]
}